import { useRef } from "react";
import { v4 as uuidv4 } from "uuid";

const sanitizeForSvgId = (value: string): string => {
  const trimmed = value.trim();
  const replaced = trimmed.replace(/[^A-Za-z0-9_-]+/g, "-");
  const collapsedDashes = replaced.replace(/-+/g, "-");
  const cleaned = collapsedDashes.replace(/^-+/, "").replace(/-+$/, "");

  if (!cleaned) return "icon";
  if (/^[A-Za-z_]/.test(cleaned)) return cleaned;

  return `i-${cleaned}`;
};

export function useIconIdPrefix(basePrefix: string): string {
  const ref = useRef<string | null>(null);

  if (!ref.current) {
    ref.current = `${sanitizeForSvgId(basePrefix)}-${uuidv4()}`;
  }

  return ref.current;
}
